var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('nav-component')],1)],1),_c('create'),_c('list'),_c('deleted-orders')],1)}
var staticRenderFns = []

export { render, staticRenderFns }